import React from 'react';
import Layout from './components/Layout';
import Home from './components/Home';
import Board from './components/Board';
import SaleBoard from './components/Controls/Sales/SaleBoard';
import ClientsBoard from './components/Controls/Clients/ClientsBoard';
import ClientCard from './components/Controls/Clients/ClientCard';
import SaleArchiveBoard from './components/Controls/Sales/SalesArchive/SaleArchiveBoard';
import Login from './components/Auth/Login'
import Scheduller from './components/Controls/Scheduller/MainScheduleBoard'
import ServersBoard from './components/Controls/Servers/ServersBoard'
import Loader from './components/Controls/Loader'
import Profile from './components/Controls/Users/Profile'
import TaskBoard from './components/Controls/Tasks/TaskBoard'
import ReportBoard from './components/Controls/Reports/ReportBoard'
import ClientBoard from './components/Controls/ClientPortal/ClientBoard'
//import ClearCache from 'react-clear-cache';
import WorkDialog from './components/Controls/Kanban/WorkDialog';
import WorkDialogExperimental from './components/Controls/ExperimentalKanban/WorkDialogExperimental';
import MainStore from './MainStore';
import SaleSchedulleEditDialog from './components/Controls/Scheduller/SaleSchedulleEditDialog';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';
import AuthStore from './components/Auth/AuthStore';
import './main.css'
import WorkFlagDialog from './components/Controls/Kanban/WorkFlagDialog';
import ProjectCalendar from './components/Controls/Projects/Chart/ProjectCalendar';
import ProjectDialog from './components/Controls/Projects/ProjectDialog';
import SuggestionsBoard from './components/Controls/Suggestions/SuggestionsBoard';
import TestBoard from './components/Controls/TestBoard';
import NewYearBoard from './components/NewYear/NewYearBoard';
import OutlookCalendar from './components/Controls/Scheduller/OutlookCalendar';
import EnvironmentProductDialog from './components/Controls/Projects/EnvironmentProductDialog';
import ServerDialog from './components/Controls/Servers/ServerDialog';
import EnvironmentDialog from './components/Controls/Servers/EnvironmentDialog';
import NavMenu from './components/NavMenu';
import { BrowserRouter, Link, NavLink, Router, Routes, Route } from 'react-router-dom';
import ProjectKanban from './components/Controls/Projects/ProjectKanban';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';

export default () => (
        
    <div>
        <Login />
        <Loader />
        <BrowserRouter>
            <Routes>
                <Route exact path='/' element={<Layout><ProjectKanban /></Layout>} />
                <Route exact path='/projects' element={<Layout><ProjectKanban /></Layout>} />
                <Route path='/board' element={<Layout><Board /></Layout>} />
                <Route path='/scheduller' element={<Layout><Scheduller /></Layout>} />
                <Route path='/profile' element={<Layout><Profile /></Layout>} />
                <Route path='/sales' element={<Layout><SaleBoard /></Layout>} />
                <Route path='/tasks' element={<Layout><TaskBoard /></Layout>} />
                <Route path='/reportsBoard' element={<Layout><ReportBoard /></Layout>} />
                <Route path='/portal' element={<Layout><ClientBoard /></Layout>} />
                <Route path='/projectCalendar' element={<Layout><ProjectCalendar /></Layout>} />
                <Route path='/salesArchive' element={<Layout><SaleArchiveBoard /></Layout>} />
                <Route path='/clients' element={<Layout><ClientsBoard /></Layout>} />
                <Route path='/client' element={<Layout><ClientCard /></Layout>} />
                <Route path='/suggestions' element={<Layout><SuggestionsBoard /></Layout>} />
                <Route path='/serversBoard' element={<Layout><ServersBoard /></Layout>} />
                <Route path='/newYear' element={<Layout><NewYearBoard /></Layout>} />
                <Route path='/calendar' element={<Layout><OutlookCalendar /></Layout>} />
            </Routes>
        </BrowserRouter>

            {!AuthStore.getUseExperimentalMode && <WorkDialog />}
            {AuthStore.getUseExperimentalMode && <WorkDialogExperimental />}
            <WorkFlagDialog />
            <SaleSchedulleEditDialog />
            <EnvironmentProductDialog />
            <EnvironmentDialog />
            <ServerDialog />
            {<ProjectDialog /*onProjectUpdate={this.handleProjectUpdate} *//>}
                <Snackbar
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    open={MainStore.isSnackBarOpen}
                    autoHideDuration={3000}
                    onClose={MainStore.closeSnackbar}
                    ContentProps={{
                        'aria-describedby': 'message-id',
                    }}
                    message={<span id="message-id">{MainStore.getSnackBarText}</span>}
                    action={[
                        <IconButton
                            key="close"
                            aria-label="Close"
                            color="inherit"
                            onClick={MainStore.closeSnackbar}
                            size="large">
                            <CloseIcon />
                        </IconButton>
                    ]}
        />
    </div>
);
